module.exports = __webpack_public_path__ + "img/no_order.ec5e0cdc.svg";